module.exports = __webpack_public_path__ + "static/media/remote_logo.ae4279f7.png";